// import { Entity, EntityConstructorParams, Hub, Interactable, RaycastTargetCircle } from '@movya-oy/storyverse-core';

// couldn't find typings for troika
// @ts-ignore
import { filter } from 'rxjs';
import { Camera, CircleGeometry, Color, Group, Material, MathUtils, Mesh, MeshBasicMaterial, Object3D, PositionalAudio, Quaternion, RingGeometry, SphereGeometry, Vector3 } from 'three';
import { EasingFunction } from './easing-utils';
import { addDepthOverride } from './material-utils';
import { Button } from './button';

export enum BasicSpotType {
  Diamond,
  Circle,
}


// From Storyverse, without any framework interactions

export class BasicSpot extends Button {

  private _maxDistance: number = 50;

  // contain the meshes under this so we can scale the parent entity freely
  protected _meshContainer: Object3D;
  protected _ring?: Mesh;
  protected _dot?: Mesh;

  protected _ringXray?: Mesh;
  protected _dotXray?: Mesh;

  protected _material: Material;
  protected _materialXray: Material;

  protected _xrayBaseOpacity = 0.0;

  protected _xrayFadeStart?: number;
  protected _xrayFadeEnd?: number;
  hoverAnimation = {
    targeted: false,
    phase: 0,
    easedPhase: 0,
    speed: 4,
    easing: EasingFunction.easeInOutQuad,
    minScale: new Vector3().setScalar(1),
    maxScale: new Vector3().setScalar(3.),
  };

  

  private _toggleOnSound?: THREE.PositionalAudio;
  private _toggleOffSound?: THREE.PositionalAudio;


  addToggleOnSound(audioBuffer: AudioBuffer, audioListener: THREE.AudioListener) {
    this._toggleOnSound = new PositionalAudio(audioListener)
    this._toggleOnSound.setBuffer(audioBuffer)
    this._toggleOnSound.setVolume(0.25)
    this._toggleOnSound.setRefDistance(1)
    this._toggleOnSound.setRolloffFactor(1)
    this._toggleOnSound.setMaxDistance(100)
    this.add(this._toggleOnSound)
  }


  addToggleOffSound(audioBuffer: AudioBuffer, audioListener: THREE.AudioListener) {
    this._toggleOffSound = new PositionalAudio(audioListener)
    this._toggleOffSound.setBuffer(audioBuffer)
    this._toggleOffSound.setVolume(0.25)
    this._toggleOffSound.setRefDistance(1)
    this._toggleOffSound.setRolloffFactor(1)
    this._toggleOffSound.setMaxDistance(100)
    this.add(this._toggleOffSound)
  }


  set isTouched(value: boolean) {
    if (!this.visible) return;
    super.isTouched = value;

    if (!this._isTouched && value){
      if (this._pressDelayTimer <= 0) {
        this._buttonAction()
        this._pressDelayTimer = this._pressDelay;
      }
      // console.log('button released')
    }

    if (this._isTouched && !value){
      // this._buttonAction()
    }
    // this.hoverAnimation.targeted = value;
  }

  stopToggleSounds() {
    if (this._toggleOnSound?.isPlaying) {
      this._toggleOnSound.stop();
    }
    if (this._toggleOffSound?.isPlaying) {
      this._toggleOffSound.stop();
    }
  }

  playToggleSound(active: boolean) {
    if (active) {
      this._toggleOnSound?.play();
    } else {
      this._toggleOffSound?.play();
    }
  }

  constructor() {
    super();

    this._meshContainer = new Object3D();
    this.add(this._meshContainer);
    // this.clickEvent = props.clickEvent ?? this.clickEvent;
    // this.maxDistance = props.maxDistance ?? this.maxDistance;

    this._material = new MeshBasicMaterial({
      // color: 0xffffff,
      color: new Color('#FF7321')
      // side: DoubleSide,
    });

    this._materialXray = this._material.clone();
    this._materialXray.opacity = 0.5;
    this._materialXray.transparent = true;
    addDepthOverride(this._materialXray, 0.5);

    // if nothing defined, use default
    if (this._dot === undefined || this._ring === undefined) {
      this.createGraphics(BasicSpotType.Diamond);
    }
    this._touchAreaIndicator.visible = false;
  }

  updateGraphicsScale(delta: number) {
    if (this._ring === undefined) return;
    const ia = this.hoverAnimation;
    ia.phase += (ia.targeted ? 1 : -1) * delta * ia.speed;
    ia.phase = MathUtils.clamp(ia.phase, 0, 1);
    ia.easedPhase = ia.easing(this.hoverAnimation.phase);
    this._ring.scale.lerpVectors(ia.minScale, ia.maxScale, ia.easedPhase);
    this._ringXray?.scale.copy(this._ring.scale);
    // console.log('ring', delta, ia.phase, ia.easedPhase);
  }

  update(cameraMiddle: Vector3, dt: number): void {
    this._meshContainer.lookAt(cameraMiddle);

    this.updateGraphicsScale(dt);

  }

  createGraphics(type: BasicSpotType) {
    // any better way to dispose?
    if (this._ring !== undefined) {
      this._ring.removeFromParent();
    }
    if (this._dot !== undefined) {
      this._dot.removeFromParent();
    }
    if (this._dotXray !== undefined) {
      this._dotXray.removeFromParent();
    }
    if (this._ringXray !== undefined) {
      this._ringXray.removeFromParent();
    }
    let ringSegments = 4;
    let dotSegments = 4;
    let dotRadius = 0.25;
    let ringOuterRadius = 1;
    let ringInnerRadius = 0.75;
    switch (type) {
      // diamond is the default
      case BasicSpotType.Diamond:
        break;

      // we want to make the round spot a bit smaller to be visually closer to the diamond in terms of surface area covered
      case BasicSpotType.Circle:
        ringSegments = 32;
        dotSegments = 16;
        ringOuterRadius = 0.85;
        ringInnerRadius = 0.65;
        dotRadius = 0.2;

        break;

      default:
        break;
    }
    const ringGeometry = new RingGeometry(ringInnerRadius, ringOuterRadius, ringSegments);
    this._ring = new Mesh(ringGeometry, this._material);

    const dotGeometry = new CircleGeometry(dotRadius, dotSegments);
    this._dot = new Mesh(dotGeometry, this._material);
    this._dot.scale.z = 0.0;

    this._ringXray = this._ring.clone();
    this._ringXray.material = this._materialXray;
    this._dotXray = this._dot.clone();
    this._dotXray.material = this._materialXray;

    this._meshContainer.add(this._ring, this._dot, this._ringXray, this._dotXray);
    this._meshContainer.scale.setScalar(0.7);
  }

}
